var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title",style:(_vm.styleCpt)},[_c('p',{},[_c('span',[_vm._v(_vm._s(_vm.pageName))]),_vm._v(" "),(_vm.fundCode)?_c('span',[_vm._v(" - ")]):_vm._e(),_vm._v(" "),(_vm.fundCode)?_c('span',[_vm._v(_vm._s(_vm.fundCode))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-331bc7c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseCpts/pageTitle.vue
// module id = null
// module chunks = 